<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaTotens(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-icon :color="item.ativo ? 'green' : 'red'">mdi-circle</v-icon>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TOTENS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer v-if="user.tipo == 'ADMIN'"></v-spacer>
              <v-btn text @click="dialogoTotem = true" tile color="#2C2E83" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false" v-if="user.tipo == 'ADMIN'">
                <v-icon left dark>add_circle</v-icon>Adicionar Totem
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="editItem(item)" color="blue darken-3">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="deleteItem(item)" color="red" v-if="user.tipo == 'ADMIN'">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar os totens</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum totem cadastrado</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum totem cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="dialogoTotem" persistent max-width="400px" scrollable>
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="totem.descricao"
                  outlined
                  label="Descrição"
                  color="#94AAB4"
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="totem.mac"
                  v-mask="'XX:XX:XX:XX:XX:XX'"
                  outlined
                  label="Endereço MAC"
                  color="#94AAB4"
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="totem.tipoCamera"
                  outlined
                  label="Tipo de câmera"
                  color="#94AAB4"
                  hide-details
                  dense
                  :items="tiposCamera"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-switch
                  style="margin-top: 5px"
                  v-model="totem.ativo"
                  label="ATIVO"
                  color="#00253E"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoTotem = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="salvarTotem">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar},
    data: () => ({
      dialogoTotem: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Descrição', value: 'descricao' },
          { text: 'Endereço MAC', value: 'mac' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      empresas: [],
      perfis: [],
      editedIndex: -1,
      totem: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        tipoCamera: "FRONTAL",
      },
      totemDefault: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        tipoCamera: "FRONTAL",
      },
      totens: [],
      tiposCamera: ['FRONTAL', 'TRASEIRA']
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo totem' : 'Editar totem'
      },
    }),

    watch: {
      dialogoTotem(val) {
        if (val == false) {
          setTimeout(() => {
            this.totem = Object.assign({}, this.totemDefault)
            this.editedIndex = -1
          }, 300)
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaProfessores(this.empresaSelecionada)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaTotens(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTotens(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        await axios.get(baseApiUrl + 'Totens?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })       
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.totem = Object.assign({}, item)
        this.dialogoTotem = true
      },

      async deleteItem(item) {
        let vm = this
        var r = confirm('Deseja realmente excluir o totem: ' + item.descricao + '?')
        
        if (r == true) {
          await axios.delete(baseApiUrl + 'Totens/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            this.carregaTotens(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        }
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async salvarTotem() {
        var vm = this

        if (this.totem.descricao || this.totem.mac || this.totem.ativo) {
          this.totem.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
          await axios.post(baseApiUrl + 'Totens/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.totem)
          .then(response => {
            if (response.data) {
              this.dialogoTotem = false
              this.carregaTotens(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },

      isValidURL(url) {
        try {
          new URL(url);
          return true;
        } catch (e) {
          return false;
        }
      },

      transformaData(data, formato) {
        return moment(data).format(formato);
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
